export function initFade() {
    if ($('body').data('scroll-fade-activated')) {

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    $(entry.target).removeClass('scroll-fade-hidden');
                }
            });
        }, {
            rootMargin: '-100px 0px 0px 0px'
        });

        const scrollContent = $('main > .frame');
        scrollContent.addClass('scroll-fade scroll-fade-hidden');
        scrollContent.each(function () {
            observer.observe(this);
        });
    }
}